import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import { ClusterSettings } from '@typings';
import { ensureArray, matchUrl, tv } from '@utils';

import { Icon, Link, Render } from '@components';

const variants = tv({
  base: 'px-6 py-2 flex items-center justify-center rounded-full capitalize gap-1.5 transition-[padding]',
  variants: {
    isActive: {
      true: 'text-white bg-rebecca pl-4',
      false: 'text-rebecca bg-white',
    },
  },
  defaultVariants: {
    isActive: false,
  },
});

type Props = {
  tabs: { title: string; path: string | string[] }[];
  setTitle?: (partial: string) => void;
};

export const AppsTabs = ({ tabs, setTitle }: Props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const tab = tabs.find(({ path }) => matchUrl(ensureArray(path), pathname));

    if (tab) {
      setTitle?.(tab.title);
    }
  }, [pathname, setTitle, tabs]);

  const makeTab = ({ path, title }: ClusterSettings.Tab) => {
    const paths = ensureArray(path);
    const isActive = matchUrl(paths, pathname);
    const [to] = paths;

    return (
      <Link theme key={to} to={to} className={variants({ isActive })}>
        <Render if={isActive}>
          <Icon icon={faCheck} className="text-[20px]" />
        </Render>
        {title}
      </Link>
    );
  };

  return <div className="flex gap-4">{tabs.map(makeTab)}</div>;
};
